import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { colors } from '../../../../../utils/styles/defaultTheme';
var _ref2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#198E59",
  strokeWidth: "1.5",
  d: "M12.058 4.727c0-1.06.91-1.977 2.106-1.977 1.195 0 2.105.917 2.105 1.977s-.91 1.978-2.105 1.978c-1.196 0-2.106-.918-2.106-1.978ZM18.144 14.06c1.196 0 2.106-.918 2.106-1.978s-.91-1.977-2.106-1.977c-1.196 0-2.105.917-2.105 1.977s.91 1.978 2.105 1.978Z"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#7BA4FE",
  strokeWidth: "1.5",
  d: "M8.077 11.835c0-1.06.91-1.978 2.106-1.978 1.196 0 2.106.918 2.106 1.978s-.91 1.977-2.106 1.977c-1.196 0-2.106-.917-2.106-1.977ZM3.75 19.273c0-1.06.91-1.978 2.106-1.978 1.196 0 2.106.918 2.106 1.978s-.91 1.977-2.106 1.977c-1.196 0-2.106-.917-2.106-1.977Z"
});
function TreeChartColor(_ref) {
  let {
    color = colors.actionMinor[500],
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: color,
    strokeWidth: "1.5",
    d: "m6.84 17.811 2.38-3.936M12.577 19.266c0 1.06.91 1.978 2.106 1.978 1.196 0 2.105-.918 2.105-1.978s-.91-1.977-2.105-1.977c-1.196 0-2.106.917-2.106 1.977ZM11.34 13.233l2.38 3.937M11.166 10.373l2.38-3.936M15.147 6.437l2.38 3.936"
  }), _ref2, _ref3);
}
export default TreeChartColor;